import CandidateNavbar from '../Candidate Navbar/Navbar';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import './Candidate_Profile.css'
import  avatar from '../../../assets/profile-avatar.png'
import validation from "./Candidate_Profile_Validation";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faDownload } from '@fortawesome/free-solid-svg-icons'
import  { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import LoadingSpinner from '../../Utils/LoadingSpinner'
export default function CandidateProfile() {

    const IMG_BASE_URL="https://pl.aspireitacademy.com/media/";
     const navigate = useNavigate();
    const [inputs, setInput] = useState({
        id: "",
        name__first_name: "",
        name__email: "",
        name__phone: "",
        addhar_number:"",
        address: "",
        gender: "",
        Dob: "",
        photo: "",
        resume: "",
        skills: "",
        qualifications: "",
        yearofpassing: "",
        percentage: ""
    });

const [profimg, setProfImg] = useState(""); //for display image after upload
const [dwnresume, setDwnresume] = useState(""); //for display image after upload
const [loader,setLoader] = useState(true);
const [errors, setErrors] = useState({});

//prevent form submitting
const handleSubmit = (e) => {
        e.preventDefault();
}

//for display image after upload
const handleImgUpload = (e)=>{
         setProfImg(URL.createObjectURL(e.target.files[0]));
         setInput({ ...inputs, [e.target.name]: e.target.files[0] })
}


const handleCVUpload = (e)=>{
         setInput({ ...inputs, [e.target.name]: e.target.files[0] })
         setErrors( { ...errors, [e.target.name]: "" });
}



const handleChange = (e) => {
   
    setInput({ ...inputs, [e.target.name]: e.target.value })
    setErrors( { ...errors, [e.target.name]: "" });
   
};




const candidateid = localStorage.getItem("user");
const id = candidateid && JSON.parse(candidateid)[0].id;
//fetch   candidate profile details

useEffect(() => {
    const user = localStorage.getItem("user");
    if(user === null){
        localStorage.removeItem("user");
        navigate('/Candidate_Login');
    }else{

        axios.get(`https://pl.aspireitacademy.com/jobseekerdetails/${id}`).then((response) => {
            setDwnresume (response.data.resume);
            setInput(response.data);
            setLoader(false);
        
        }).catch(error => {
            toast.error("Something Went Wrong")  ;
            setLoader(false);
        });
    }
}, []);


     //=======================put api for update candidate details=============================
    const candidateReg = () => {
        const validationstatus = validation(inputs);
        if (!validationstatus.status) {
          setErrors(validationstatus.errors);
        
        } else{
           
       
        const data = new FormData() 
        data.append('name__first_name', inputs.name__first_name);
        data.append('name__email', inputs.name__email);
        data.append('name__phone', inputs.name__phone);
        data.append('addhar_number', inputs.addhar_number);
        data.append('address', inputs.address);
        data.append('gender', inputs.gender);
        data.append('photo', inputs.photo);
        data.append('resume', inputs.resume);
        data.append('skills', inputs.skills);
        data.append('qualifications', inputs.qualifications);
        data.append('yearofpassing', inputs.yearofpassing);
        data.append('percentage', inputs.percentage);
        data.append('Dob', inputs.Dob);
       
        axios.put(`https://pl.aspireitacademy.com/jobseekerupdate/${id}`,data,{

        }).then(res => {
            let response_id = res.data[0].id;
            if(response_id){
                toast.success("Profile Updated Successfully",{
                    toastId: 'error6',});
                navigate("/Candidate_Dashboard", {
                    state: {
                            userId: id,
                        },
                        })
            }else{
                toast.error( res.data.trim(), {
                    toastId: 'error1',
                })  ;
            }
        }).catch(function (error) {
            toast.error("Something Went Wrong", {
                toastId: 'error2',
            })  ;
        })

    }
    }

    const downloadResume = () =>{
        const url =IMG_BASE_URL+dwnresume;
        saveAs(url,id);
    }

    return (
        <section className='profile-update'>
            <CandidateNavbar />
            { loader ? <LoadingSpinner />: 
            <div className='container-fluid m-0  ' >
            <form id='Candidate_form' onSubmit={handleSubmit} >
                <div className="row p-4 d-flex  justify-content-around " >


        <div className="col-md-3 "  style={{backgroundColor:'#fbfbfb'}} >
                    <h4 className='text-center my-3 page-title' >Edit Profile</h4>

    <div className="d-flex flex-column align-items-center  ">
        <div className="d-flex flex-sm-column align-items-center justify-content-between"  >
        <img className='mb-4 rounded-circle prof-img' width="170px" height="170px" 
        src={profimg?profimg:
        inputs.photo?IMG_BASE_URL+inputs.photo:
        avatar } />
        <div className="upload-btn-wrapper mb-4 ms-5 ms-sm-0">
            <button className="btn pro-upload-btn" >Upload</button>
            <input type="file" name="photo" accept="image/*" onChange={handleImgUpload}/>
         </div>
         </div>

{/* upload resume section starts         */}
<div className='  pro-cv-container  mb-5'>

        <h6 style={{color:"#337ab7"}}>Upload Resume</h6>
        <div className="resume-container" >
            <div className='d-flex justify-content-between px-2'>
                {  
                    dwnresume? 
                    <>
                    <p style={{fontSize:'12px'}}>{dwnresume}</p>
                    <p style={{fontSize:'12px',cursor:'pointer'}} onClick = {()=>{downloadResume()}}> <FontAwesomeIcon icon={faDownload} /></p>    
                    </>:''
                }
            </div>  
           
           <input type="file" name="resume" className='fileresume' width="50px" accept=".docx,.pdf,.rtf,.doc" onChange={handleCVUpload}/>
          
        </div>
        <span className="reg-error-msg">
            {errors.resume ? errors.resume : ""}
        </span>
</div>
{/* upload resume section ends */}
       
 </div>


                    </div>



                    <div className="col-md-4 border-right" >
                        <div className="col-md-12 mb-3">
                            <label className="labels">Name</label>
                            <input type="text"
                                  className="form-control"
                                  placeholder="Enter Name"
                                  name="name__first_name"
                                  onChange={(e)=>{handleChange(e)}}
                                  value={inputs.name__first_name?inputs.name__first_name:''} />
                            <span className="reg-error-msg">
                                {errors.name__first_name ? errors.name__first_name : ""}
                            </span>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="labels">Phone</label>
                            <input type="number"
                             className="form-control"
                             placeholder="Enter Phone Number"
                             name="name__phone"
                             maxLength={10}
                             onChange={(e)=>{handleChange(e)}}
                             value={inputs.name__phone?inputs.name__phone:''} />
                            <span className="reg-error-msg">
                                {errors.name__phone ? errors.name__phone : ""}
                            </span>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="labels">Email</label>
                            <input type="email" 
                            className="form-control"
                            placeholder="Enter Email" 
                            name="name__email"
                            onChange={(e)=>{handleChange(e)}}
                            value={inputs.name__email?inputs.name__email:''}  />
                            <span className="reg-error-msg">
                                {errors.name__email ? errors.name__email : ""}
                            </span>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="labels">Aadhaar Number</label>
                            <input 
                                type="number" 
                                className="form-control"
                                placeholder="Enter Aadhaar Number" 
                                name="addhar_number"
                                maxLength={12}
                                onChange={(e)=>{handleChange(e)}}
                                value={inputs.addhar_number?inputs.addhar_number:''}  />
                            <span className="reg-error-msg">
                                {errors.addhar_number ? errors.addhar_number : ""}
                            </span>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="labels">Address</label>
                            <textarea 
                                name="address" 
                                 rows="4"
                                
                                 className="form-control" 
                                 onChange={(e)=>{handleChange(e)}}
                                 value={inputs.address?inputs.address:''}></textarea>
                             <span className="reg-error-msg">
                                {errors.address ? errors.address : ""}
                            </span>
                           
                        </div>
                    </div>


                    <div className="col-md-4" >
                    <div className="col-md-12 mb-3">
                        <label htmlFor="gender" className="form-label text-start">Gender:</label>
                        <span className="reg-error-msg" style={{display:'inline',marginLeft:'5px'}}>
                                {errors.gender ? errors.gender : ""}
                            </span>
                       <div>
                       <div className="form-check form-check-inline">
                            <input type="radio" className="form-check-input" name="gender" onChange={(e)=>{handleChange(e)}} 
                            checked={inputs.gender === "Male" || inputs.gender === "male" || inputs.gender === false} value='Male' />
                            <label className="form-check-label" htmlFor="radio1" style={{color:'#000'}}>Male</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input type="radio" className="form-check-input" name="gender" onChange={(e)=>{handleChange(e)}} 
                            checked={inputs.gender === "Female" || inputs.gender === "female" || inputs.gender === false} value='Female' />
                            <label className="form-check-label" htmlFor="radio2" style={{color:'#000'}} >Female</label>
                        </div>
                       </div>
                       
                    </div>
     
                    <div className="col-md-12 mb-3">
                            <label className="labels">Date of Birth</label>
                            <input type="date"
                             name="Dob"
                             className="form-control"
                             onChange={(e)=>{handleChange(e)}}
                            value={inputs.Dob?inputs.Dob:''} />
                              <span className="reg-error-msg">
                                {errors.Dob ? errors.Dob : ""}
                            </span>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="labels">Qualification</label>
                            <input type="text"
                            className="form-control"
                            placeholder="Enter Qualification"
                            name="qualifications"
                            onChange={(e)=>{handleChange(e)}}
                             value={inputs.qualifications?inputs.qualifications:''} />
                            <span className="reg-error-msg">
                                {errors.qualifications ? errors.qualifications : ""}
                            </span>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="labels">Year of Passout</label>
                            <input type="number"
                             className="form-control"
                             name="yearofpassing"
                             placeholder="YYYY" 
                             onChange={(e)=>{handleChange(e)}}
                             value={inputs.yearofpassing?inputs.yearofpassing:''} />
                            <span className="reg-error-msg">
                                {errors.yearofpassing ? errors.yearofpassing : ""}
                            </span>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="labels">Mark Percentage</label>
                            <input type="number"
                            
                             className="form-control"
                             name="percentage"
                             placeholder="Enter mark in percentage"
                             onChange={(e)=>{handleChange(e)}}
                             value={inputs.percentage?inputs.percentage:''} />
                             <span className="reg-error-msg">
                                {errors.percentage ? errors.percentage : ""}
                            </span>
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="labels">Skills</label>
                            <input type="text" 
                            className="form-control"
                            placeholder="Enter Skills" 
                            name="skills"
                            onChange={(e)=>{handleChange(e)}}
                            value={inputs.skills?inputs.skills:''} />
                        </div>
                        <div className="col-md-12 mb-3 text-end">
                           <button className='btn btn-primary profile-button'
                           onClick={candidateReg}>Submit</button>
                        </div>
                    </div>
                </div>
              
              </form>  
            </div>}
        </section>
    )
}